import { GridFields } from 'components';
import { styled } from 'libs/ui/styled';

interface Props {
  leftContent: React.ReactNode;
  rightContent: React.ReactNode;
  className?: string;
  gridTemplateColumns?: string;
}

export const SettingsContentStyled = styled('div')<{
  gridTemplateColumns?: string;
}>(({ gridTemplateColumns = '1fr 3fr' }) => ({
  display: 'grid',
  gridTemplateColumns,
  alignItems: 'flex-start',
  padding: '24px 0',
  gap: 16,
}));

export const SettingsContent = ({
  leftContent,
  rightContent,
  gridTemplateColumns,
  className,
}: Props) => (
  <SettingsContentStyled
    className={className}
    gridTemplateColumns={gridTemplateColumns}
  >
    {leftContent} <GridFields>{rightContent}</GridFields>
  </SettingsContentStyled>
);
